import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Truyen du lieu row bang list sang man view-document truoc khi navigate:
 * man detail hien ngay thong tin co ban (code/name/serviceType/BCT/status) khong cho API detail.
 * API detail + list-user-sign van chay background va ghi de ket qua khi ve.
 * Ko co prefill (F5, truy cap truc tiep link, notification): man detail tu fallback skeleton nhu cu.
 */
@Injectable({providedIn: 'root'})
export class DocumentPrefillService {

  private prefill$ = new BehaviorSubject<{id: string, row: any}>(null);

  /** List screen goi truoc khi navigate sang view-document */
  setPrefill(id: string, row: any): void {
    this.prefill$.next({id, row});
  }

  /** Man view-document doc 1 lan khi mount; tra ve null neu khong co (hoac khong dung id) */
  takePrefill(id: string): any {
    const current = this.prefill$.getValue();
    if (current && current.id === id) {
      this.prefill$.next(null);
      return current.row;
    }
    return null;
  }
}
